<template>
    <div class="premium-interior-flex pristine-interior flex items-center xl:flex-no-wrap xl:flex-row md:flex-wrap md:flex-col">
        <div class="premium-interior-left relative xl:w-6/12 xl:m-0 md:w-w550 md:ml-auto md:mr-auto">
            <img src="../../../assets/images/premium3.jpg" alt="Premium" class="block w-full pl-spc27 md:pl-0">
        </div>
        <div class="premium-interior-right xl:w-6/12 xl:px-spc19 xl:max-w-Max420 md:w-w420 md:py-6 md:px-0">
            <h3 class="text-14 font-bold text-white py-2 leading-spc5 tracking-space2">
                Pristine Sound
            </h3>
            <p class="text-14 leading-spc5 text-white">
                A custom audio system featuring 17 speakers with neodymium magnets.
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InteriorPristine"
    }
</script>

<style scoped>

</style>